export default __webpack_public_path__ + "static/media/Geography.5080a7b4.gif";